import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import { getSingleProduct } from "../../actions/itemActions";
import BuyingBox from "../../components/BuyingBox/BuyingBox";
import DescriptionBoxProduct from "../../components/DescriptionBoxProduct/DescriptionBoxProduct";
import Navbar from "../../components/Navbar/Navbar";
import PhotoboxProduct from "../../components/PhotoboxProduct/PhotoboxProduct";
import Footer from "../../components/Footer/Footer";
import Loader from "../Product/Loader";

const DetailProduct = () => {
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();

  const itemFromState = location.state?.item;
  const [item, setItem] = useState(itemFromState || null);

  const { loading, selectedItem } = useSelector((state) => state.itemReducer);

  useEffect(() => {
    if (!item && id) dispatch(getSingleProduct(id));
  }, [dispatch, id, item]);

  useEffect(() => {
    if (!item && selectedItem && String(selectedItem.id) === String(id)) {
      setItem(selectedItem);
    }
  }, [selectedItem, id, item]);

  return (
    <div>
      <Navbar />
      <Container className="m-2">
        <h1>Product Details</h1>
        {loading || !item ? (
          <Loader />
        ) : (
          <Row>
            <Col md={5}><PhotoboxProduct id={item.id} /></Col>
            <Col md={5}><DescriptionBoxProduct item={item} /></Col>
            <Col md={2}><BuyingBox productId={item.id} stock={item.stock} item={item} /></Col>
          </Row>
        )}
      </Container>
      <Footer />
    </div>
  );
};

export default DetailProduct;
